function App() {
  return (
    <div
      style={{
        height: '100vh',
        backgroundColor: '#f5f5f5',
        display: 'flex',
        alignItems: 'flex-start',   // ⬅️ Move content to top
        justifyContent: 'center',   // Still center horizontally
        paddingTop: '100px',         // ⬅️ Adjust top gap as you like
        paddingLeft: '40px',
        paddingRight: '40px',
        overflow: 'hidden',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
      }}
    >
      <div style={{
        width: '100%',
        maxWidth: '800px',
        textAlign: 'center',
        maxHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        padding: '80px'
      }}>
        {/* Logo */}
        <div style={{ marginBottom: '2px', display: 'flex', justifyContent: 'center' }}>
          <img 
            src="/NeuraLogo.png" 
            alt="NeuraIntelligence Logo" 
            style={{
              width: '350px',
              height: 'auto',
              display: 'block',
              maxHeight: '30vh',
              objectFit: 'contain'
            }}
          />
        </div>

        {/* Description */}
        <p style={{
          fontSize: '18px',
          lineHeight: '1.4',
          color: '#5c5c5cff',
          maxWidth: '800px',
          margin: '0 auto',
          fontWeight: '500',
          padding: '0 20px',
          textAlign: 'center'
        }}>
          NeuraIntelligence offers consulting in machine learning and full-stack web development. We also
          provide expertise in computing and applied mathematics, including Monte Carlo methods and
          the design of efficient algorithms for large-scale computing.
        </p>
      </div>
    </div>
  );
}

export default App;